import { action } from 'satcheljs';
import { SaveCalendarViewConfig } from 'owa-save-calendar-view-data';

export const showAddOrEditSaveViewDialog = action(
    'showAddOrEditSaveViewDialog',
    (saveCalendarViewConfig: SaveCalendarViewConfig) => ({
        saveCalendarViewConfig,
    })
);
export const hideAddOrEditSaveViewDialog = action('hideAddOrEditSaveViewDialog');

export const showDeleteSavedViewDialog = action(
    'showDeleteSavedViewDialog',
    (saveCalendarViewConfig: SaveCalendarViewConfig) => ({
        saveCalendarViewConfig,
    })
);
